// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 0;
  z-index: 1000;
  background-color: transparent;
  touch-action: none;
}

.slider-container {
  position: relative;
  margin: 0 0 0 auto;
  height: 12vw;
  width: 72vw;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 1001;
  padding: 0;
  border-radius: 50px;
  touch-action: none;
  box-shadow: var(--shadow-side-anim-end);
  backdrop-filter: blur(8px);
  background: rgba(255, 255, 255, 0.28);
  border: 0px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 0 24px -12px rgb(255, 255, 255);
}

.slider-handle {
  position: absolute;
  top: 0;
  left: 0vw;
  width: 24vw;
  height: 12vw;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  touch-action: none;
  overflow: visible;
  transition: all 0.2s cubic-bezier(1, 1.9, 0.25, 1.9);
}

.jiggler {
  width: 22vw;
  height: 10vw;
  margin: 1vw;
  border-radius: 50px;
  position: relative;
  overflow: hidden;
  z-index: 500;
  touch-action: none;
  box-shadow: var(--shadow-h);
  pointer-events: none;
}

.jiggler {
  background: linear-gradient(40deg, hsl(var(--drop-color-primary)/0.9) 0%, hsl(var(--drop-shadeDark-primary)/0.8) 30%, hsl(var(--drop-color-primary)/0.7) 60%, hsl(var(--drop-shadeDark-primary)/0.8) 100%);
  background-size: 150% 120%;
  background-position: 0 0;
  background-repeat: no-repeat;
}

.uiLast {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 12vw;
  width: 12vw;
  margin: 0 auto;
  z-index: 2;
  position: relative;
  border-radius: 50%;
  pointer-events: all;
  padding: 0;
  transition: all 0.2s cubic-bezier(1, 1, 0.25, 1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  background: linear-gradient(20deg, hsl(var(--drop-color-primary)/1) 0%, hsl(var(--drop-light-primary)/0.5) 50%, hsl(var(--drop-bright-tertiary)/0) 100%);
  background-size: 340% 340%;
  background-position: 100% 20%;
  background-repeat: no-repeat;
  box-shadow: var(--shadow-minor-anim-end), inset -2px 2px 10px -5px hsl(var(--drop-white-tertiary)/0.2), inset -2px -2px 3px -2px hsl(var(--drop-white-tertiary)/0.2), inset 0 -2px 0 hsl(var(--drop-white-tertiary)/0.3);
}
.uiLast ion-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 6vw;
  height: 6vw;
  transition: all 0.2s cubic-bezier(1, 1.9, 0.25, 1.9);
}

.selectedLast {
  box-shadow: var(--shadow-h);
  pointer-events: none !important;
  background-position: 100% 100%;
}
.selectedLast ion-icon {
  color: var(--ion-text-primary);
  fill: var(--ion-text-primary);
  stroke: var(--ion-text-primary);
  width: 6vw;
  height: 6vw;
  filter: drop-shadow(-1px 1px 2px var(--ion-fade-primary));
}

.marker {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 8vw;
  width: 24vw;
  position: relative;
  background: transparent;
  padding: 1vh 0;
  transition: all 0.2s cubic-bezier(1, 1.9, 0.25, 1.9);
}

.noClick {
  pointer-events: none;
  z-index: 2;
}

.canClick {
  pointer-events: auto;
  z-index: 2;
}

.selectedIcon {
  color: var(--ion-text-primary);
  fill: var(--ion-text-primary);
  stroke: var(--ion-text-primary);
}

.unSelectedIcon {
  color: var(--ion-color-primary);
  fill: var(--ion-color-primary);
  stroke: var(--ion-color-primary);
}

.iconF {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 6vw;
  height: 6vw;
  transition: all 0.2s cubic-bezier(1, 1.9, 0.25, 1.9);
}`, "",{"version":3,"sources":["webpack://./src/app/components/slide-bar/slide-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACF,uCAAA;EAEE,0BAAA;EAEA,qCAAA;EACA,0CAAA;EACA,mKACE;AAFJ;;AAQA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EAEA,oDAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,YAAA;EAGA,kBAAA;EAGA,2BAAA;EACF,oBAAA;AAXA;;AA4BA;EAEE,0MAAA;EAEA,0BAAA;EACA,wBAAA;EACA,4BAAA;AA3BF;;AAgCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,gDAAA;EAEA,0BAAA;EACA,kCAAA;EACA,wJAAA;EACA,0BAAA;EACA,6BAAA;EACA,4BAAA;EACA,wNAAA;AA9BF;AAmCE;EAIE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,oDAAA;AApCJ;;AAwDA;EACE,2BAAA;EACA,+BAAA;EACA,8BAAA;AArDF;AAuDE;EACE,8BAAA;EACA,6BAAA;EACA,+BAAA;EACA,UAAA;EACA,WAAA;EACA,yDAAA;AArDJ;;AA4DA;EAKI,OAAA;EACF,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EAEA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,oDAAA;AA9DF;;AAgEA;EACI,oBAAA;EACF,UAAA;AA7DF;;AA+DA;EACI,oBAAA;EACF,UAAA;AA5DF;;AA8DA;EACI,8BAAA;EACF,6BAAA;EACA,+BAAA;AA3DF;;AA6DA;EACE,+BAAA;EACA,8BAAA;EACA,gCAAA;AA1DF;;AA4DA;EACC,aAAA;EACG,mBAAA;EACA,uBAAA;EACF,UAAA;EACA,WAAA;EAEA,oDAAA;AA1DF","sourcesContent":[":host {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  border-radius: 0;\n  z-index: 1000;\n  background-color: transparent;\n  touch-action: none;\n}\n\n.slider-container {\n  position: relative;\n  margin: 0 0 0 auto;\n  height: 12vw;\n  width: 72vw;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  z-index: 1001;\n  padding: 0;\n  border-radius: 50px;\n  touch-action: none;\nbox-shadow: var(--shadow-side-anim-end);\n// box-shadow: var(--shadow-glass-anim-end);\n  backdrop-filter: blur(8px);\n  // -webkit-backdrop-filter: blur(8px) saturate(120%) contrast(1.3);\n  background: rgba(255, 255, 255, 0.28);\n  border: 0px solid rgba(255, 255, 255, 0.3);\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.5),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.1),\n    inset 0 0 24px -12px rgba(255, 255, 255, 1.2);\n}\n\n.slider-handle {\n  position: absolute;\n  top: 0;\n  left: 0vw;\n  width: 24vw;\n  height: 12vw;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  touch-action: none;\n  overflow: visible;\n  // transition: all 0.3s ease-in-out;\n  transition: all 0.2s cubic-bezier(1, 1.9, 0.25, 1.9);\n\n}\n.jiggler {\n  width: 22vw;\n  height: 10vw;\n  margin: 1vw;\n  border-radius: 50px;\n  position: relative;\n  overflow: hidden;\n// opacity: 0.8;\n  z-index: 500;\n  // transition: all 0.2s ease-in-out;\n  // transition: all 0.2s cubic-bezier(1, 1.9, 0.25, 1.9);\n  touch-action: none;\n  // backdrop-filter: blur(5px) saturate(120%) contrast(1.3);\n  // -webkit-backdrop-filter: blur(5px) saturate(120%) contrast(1.3);\n  box-shadow: var(--shadow-h);\npointer-events: none;\n  // &::before {\n  //   content: '';\n  //   position: absolute;\n  // height: 100%;\n  // left: 0%;\n  // top: 0%;\n  // width: 100%;\n  //   border: 2px solid var(--ion-color-secondary);\n  // opacity: 1;\n  //   filter: blur(2px);\n  //   pointer-events: none;\n  //   border-radius: 50px;\n  //   // transition: all 0.3s ease-in-out;\n  //   // transform: translateX(-50%) translateY(-50%) rotate(0deg) scale(1);\n  // }\n}\n.jiggler {\n\n  background: linear-gradient(40deg,hsl(var(--drop-color-primary)/0.9) 0%, hsl(var(--drop-shadeDark-primary)/0.8) 30%, hsl(var(--drop-color-primary)/0.7) 60%,hsl(var(--drop-shadeDark-primary)/0.8) 100%);\n  // transition: all 1s ease-in-out;\n  background-size: 150% 120%;\n  background-position: 0 0;\n  background-repeat: no-repeat;\n\n\n}\n\n.uiLast {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  height: 12vw;\n  width: 12vw;\n  margin: 0 auto;\n  z-index: 2;\n  position: relative;\n  border-radius: 50%;\n  pointer-events: all;\n  padding: 0;\n  transition: all 0.2s cubic-bezier(1, 1, 0.25, 1);\n\n  backdrop-filter: blur(8px) ;\n  -webkit-backdrop-filter: blur(8px) ;\n  background: linear-gradient(20deg, hsl(var(--drop-color-primary)/1) 0%, hsl(var(--drop-light-primary)/0.5) 50%, hsl(var(--drop-bright-tertiary)/0) 100%);\n  background-size: 340% 340%;\n  background-position: 100% 20%;\n  background-repeat: no-repeat;\n  box-shadow: var(--shadow-minor-anim-end),\n    inset -2px 2px 10px -5px hsl(var(--drop-white-tertiary)/0.2),\n    inset -2px -2px 3px -2px hsl(var(--drop-white-tertiary)/0.2),\n    inset 0 -2px 0 hsl(var(--drop-white-tertiary)/0.3);\n\n  ion-icon {\n    // color: var(--ion-color-primary);\n    // fill: var(--ion-color-primary);\n    // stroke: var(--ion-color-primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 6vw;\n    height: 6vw;\n    transition: all 0.2s cubic-bezier(1, 1.9, 0.25, 1.9);\n  }\n\n  // &::before {\n  //   content: '';\n  //   position: absolute;\n  //   top: 0;\n  //   left: 0;\n  //   width: 100%;\n  //   height: 100%;\n  //   background: linear-gradient(20deg,\n  //       hsl(var(--drop-color-tertiary)/0.05) 0%,\n  //       hsl(var(--drop-white-tertiary)/0.1) 50%,\n  //       hsl(var(--drop-color-tertiary)/0.05) 100%);\n  //   pointer-events: none;\n  //   background-size: 200% 200%;\n  //   background-position: 0% 100%;\n  //   border-radius: 50%;\n  // }\n}\n.selectedLast {\n  box-shadow: var(--shadow-h);\n  pointer-events: none !important;\n  background-position: 100% 100%;\n\n  ion-icon {\n    color: var(--ion-text-primary);\n    fill: var(--ion-text-primary);\n    stroke: var(--ion-text-primary);\n    width: 6vw;\n    height: 6vw;\n    filter: drop-shadow(-1px 1px 2px var(--ion-fade-primary));\n  }\n\n  // &::before {\n  //   background-position: 100% 0%;\n  // }\n}\n.marker{\n  // width: 24vw;\n  // height: 12vw;\n  // position: relative;\n  // opacity: 1;\n    flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  height: 8vw;\n  width: 24vw;\n  position: relative;\n  background: transparent;\n  padding: 1vh 0;\n  transition: all 0.2s cubic-bezier(1, 1.9, 0.25, 1.9);\n}\n.noClick{\n    pointer-events: none;\n  z-index: 2;\n}\n.canClick{\n    pointer-events: auto;\n  z-index: 2;\n}\n.selectedIcon{\n    color: var(--ion-text-primary);\n  fill: var(--ion-text-primary);\n  stroke: var(--ion-text-primary);\n}\n.unSelectedIcon{\n  color: var(--ion-color-primary);\n  fill: var(--ion-color-primary);\n  stroke: var(--ion-color-primary);\n}\n.iconF {\n display: flex;\n    align-items: center;\n    justify-content: center;\n  width: 6vw;\n  height: 6vw;\n  // filter: drop-shadow(-1px 1px 2px var(--ion-fade-primary));\n  transition: all 0.2s cubic-bezier(1, 1.9, 0.25, 1.9);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
